<template>
        <input 
            type="text" 
            :placeholder="placeholder" 
            :name="name" 
            :id="id" 
            :maxlength="maxlength"
            :class="myclass" 
            :required="required" 
            v-model="inputVal" 
            :style="mystyle ? mystyle : ''"
        >
</template>

<script>
export default {
    name: 'TextField',
    data() {
        return {
            classs : this.class,
        }
    },
    props: [
        'value',
        'placeholder',
        'myclass',
        'id',
        'maxlength',
        'name',
        'mystyle',
        'required',
        'characterAllow'
    ],
    mounted() {
        var charactherAllow = this.characterAllow;
        document.getElementById(this.id).onkeypress = function (e) {
            var chr = String.fromCharCode(e.which);
            if (charactherAllow.indexOf(chr) < 0) return false;
        };
    },
    computed: {
        inputVal: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    }
}
</script>
